import { t } from 'i18next';
import { isEmpty, isUndefined } from 'lodash';
import { Virtuoso } from 'react-virtuoso';
import GridSkeletons from '../skeletons/GridSkeletons';
import NotificationItem from './NotificationItem';

export default function NewNotificationTabPanel({ notifications, loadMore }) {
  if (isUndefined(notifications)) {
    return <GridSkeletons gridSize={1} skeletonSize={3} skeletonHeight={'60px'} />;
  }
  if (isEmpty(notifications)) {
    return (
      <div className="flex flex-col items-center gap-[12px] mt-[130px]">
        <img
          src="/assets/icons/graphic-3d/3D.bell.png"
          alt="empty-bell"
          className="w-[68px] h-[85px]"
        />
        <div className="px-[24px] py-[10px] flex flex-col gap-[14px] text-center">
          <p className="text-[17px] font-bold text-text-main-lv2 leading-none">
            {t('notifications.emptyNotificationCase.title')}
          </p>
          <p className="text-[14px] font-medium text-text-main-lv4 leading-tight whitespace-pre-line">
            {t('notifications.emptyNotificationCase.description')}
          </p>
        </div>
      </div>
    );
  }
  return (
    <div>
      <Virtuoso
        useWindowScroll
        overscan={480}
        data={notifications}
        endReached={loadMore}
        style={{ height: '100px' }}
        itemContent={(_, notification) => (
          <div key={notification.notificationId}>
            <NotificationItem key={notification.notificationId} notification={notification} />
          </div>
        )}
      />
    </div>
  );
}
